/**
 * This patch migrates detail page links inside Rich Text elements to have
 * collection id in addition to item id.
 */
import _ from 'lodash';
import type {Context} from '../types';

// Inline util to check types of links from when this patch was introduced
const isLinkPage = function (data: any): boolean {
  return Boolean(data && data.link && data.link.mode === 'page');
};

export default (context: Context) => {
  const {
    node: {
      jsonNode: {data: nodeData = {}, _id},
    },
    extraContext: {collections},
  } = context;

  const isPageLink = isLinkPage(nodeData);
  const isDetailPageLink = isPageLink && nodeData.link.itemId;
  const href =
    isDetailPageLink && nodeData && nodeData.attr && nodeData.attr.href;
  const splitHref = typeof href === 'string' && href.split('/');
  const collectionSlug = splitHref && splitHref[1];
  const collection =
    collectionSlug && _.find(collections, {slug: collectionSlug});

  return {
    needed: Boolean(collection && !nodeData.link.collectionId),
    logData: {
      msg: 'Detail page link inside Rich Text element does not have collection id',
      meta: {
        nodeId: _id,
      },
    },
    apply: () => {
      // This is already checked in `needed` above but we need this for Flow type check to pass.
      if (collection) {
        nodeData.link.collectionId = collection._id;
      }
    },
  };
};
